import * as commonActions from './common'

export default {
    ...commonActions
}

